"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatTileBadge = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const apiService_1 = __importDefault(require("../../../common/services/apiService"));
const ChatTileBadgeWrp = styled_components_1.default.div `
  border-radius: 50%;
  background-color: #ff3b30;
  color: white;
  position: absolute;
  right: 4px;
  top: 5px;
  padding: 4px;
  font-size: 14px;
  height: 25px;
  width: 25px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const ChatTileBadge = ({ userData, currentLocale }) => {
    const [count, setCount] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        apiService_1.default.getChatCount(currentLocale, userData.token).then((data) => {
            setCount(data.overview.chat.count);
        });
    }, []);
    const display = count > 9 ? "9+" : `${count}`;
    if (count === 0) {
        return null;
    }
    return (react_1.default.createElement(ChatTileBadgeWrp, null,
        react_1.default.createElement("span", null, count !== 0 && display)));
};
exports.ChatTileBadge = ChatTileBadge;
const mapStoreToProps = (store) => ({
    userData: store.getValue("userData"),
    currentLocale: store.getValue("currentLocale"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(exports.ChatTileBadge);
